<template>
<!--        <span><img-->
<!--                style="margin-left: 2px; margin-top: 12px; max-width: 67px; max-height: 42px"-->
<!--                :src="require('../../assets/img/LogoMin.png')"-->
<!--                alt=""-->
<!--        /></span>-->


    <span><img
            style="margin-left: 2px; margin-top: 12px; max-width: 67px; max-height: 42px"
            :src="require('../../assets/img/kp.jpg')"
            alt=""
    /></span>
</template>

<script>
    export default {
        name: "Logo"
    }
</script>

<style scoped>

</style>